import React, { useEffect, useState } from "react";
import "../../Styles/NFTbox.css";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Dashboardheader from "../../directives/dashboardheader";
import config from "../../config/config";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import toast from "react-hot-toast";
import Web3 from "web3";
import Cookies from "js-cookie";
import {
  getboxDetailsAction,
  getBoxInvestmentHistoryAction,
  getDataForNftDetailsAction,
} from "../../Action/user.action";
import { Vortex } from "react-loader-spinner";
import CopyToClipboard from "react-copy-to-clipboard";
import NftsuccessfulModal from "../Modals/NftsuccessfulModal";

const NftboxDetails = () => {
  const navigate = useNavigate();
  const [buyTransactionHash, setbuyTransactionHash] = useState("");
  const [MintingTimer, setMintingTimer] = useState("");
  const [transactionError, settransactionError] = useState("");
  const [showNftSuccessModal, setShowNftSuccessModal] = useState(false);
  const [nftBoxDetails, setNftBoxDetails] = useState([]);
  const [rewardCategoriesDetails, setRewardCategoriesDetails] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalLoad, setShowModalLoad] = useState(false);
  const [process, setprocess] = useState("");

  const [nftHystory, setnftHystory] = useState([]);
  const [page, setPage] = useState(1);
  const [paginationStatus, setpaginationStatus] = useState(false);

  console.log(rewardCategoriesDetails);

  let { nftBoxValue, mntPrice } = useParams();

  const handleShowNftSuccessPop = () => {
    setShowNftSuccessModal(true);
  };
  const handleCloseNftSuccessPop = () => {
    setShowNftSuccessModal(false);
  };

  const loginData = !Cookies.get("loginSuccessStepMrMint", {
    domain: "mrmint.io",
  })
    ? []
    : JSON.parse(
        Cookies.get("loginSuccessStepMrMint", { domain: "mrmint.io" })
      );

  useEffect(() => {
    if (nftBoxValue == 0) {
      navigate(`${config.baseUrl}nftbox`);
    } else {
      getDataForNftDetails();
    }
  }, []);

  useEffect(() => {
    getBoxInvestmentHistory();
  }, [page]);

  const handleAddMore = () => {
    navigate(`${config.baseUrl}nftbox`, { state: { nftBoxValue } });
  };

  // NFT Box purchasing functions
  const approve = async (
    abi,
    contractAddress,
    amount,
    toAddress,
    from_address
  ) => {
    setprocess("Your approval is processing");

    let web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(abi, contractAddress);
    let allowance = await contract.methods
      .allowance(from_address, toAddress)
      .call();

    allowance = parseFloat((parseInt(allowance) / 10 ** 18).toFixed(6));
    console.log({ allowance, amount });
    if (allowance >= amount) {
      return true;
    }
    amount = web3.utils.toWei(amount.toString(), "ether");
    console.log({ amount });
    try {
      let approve = await contract.methods.approve(toAddress, amount);
      let encoded_tx = approve.encodeABI();
      let gasPrice = await web3.eth.getGasPrice();

      //fees for approval & buyPlan trx
      let getBalace = await web3.eth.getBalance(from_address);
      let fees = ((47000 + 285000) * parseInt(gasPrice)) / 10 ** 18;
      let currentBal = parseFloat((parseInt(getBalace) / 10 ** 18).toFixed(6));
      if (fees > currentBal) {
        toast.error(
          `Insufficient gas fee for transaction, Minimum ${parseFloat(
            fees
          ).toFixed(6)} BNB balanace required for transaction`
        );
        setShowModal(false);
        return false;
      }

      let gasLimit = await web3.eth.estimateGas({
        gasPrice: web3.utils.toHex(gasPrice),
        to: contractAddress,
        from: from_address,
        data: encoded_tx,
      });
      let trx = await web3.eth.sendTransaction({
        gasPrice: web3.utils.toHex(gasPrice),
        gas: web3.utils.toHex(gasLimit),
        to: contractAddress,
        from: from_address,
        data: encoded_tx,
      });
      if (trx.transactionHash) {
        console.log("trx.transactionHash", trx.transactionHash);
        return true;
      } else {
        toast.error("User Reject Approval");
        setShowModal(false);
        return false;
      }
    } catch (err) {
      if (err.code == 4001) {
        toast.error("User Reject Approval");
      } else if (err.code == -32603) {
        toast.error("Insufficient Allowance");
      } else {
        toast.error(err.message);
      }
      setShowModal(false);
      return false;
    }
  };

  const handleBuyNFTBox = async (e, id) => {
    if (!nftBoxValue) {
      toast.error("Please Nft Box Value");
      return;
    }
    try {
      if (loginData.bnb_address == null) {
        // handleWalleteVerificationModal(e);
      } else {
        setShowModal(true);
        setprocess("Your Transaction is processing");
        // if (!loginData.id) {
        //   setShowModal(false);
        //   toast.error(
        //     "You need to connect with your Meta mask Wallet before purchase"
        //   );
        //   return;
        // }
        if (window.ethereum) {
          let web3 = new Web3(window.ethereum);

          let chainId;
          try {
            chainId = await web3.currentProvider.chainId;
            if (!chainId) {
              chainId = await web3.currentProvider.getChainId();
            }
          } catch (error) {
            window.location.reload();
            return false;
          }
          if (
            chainId != config.chainId &&
            web3.utils.toHex(parseInt(chainId)) != config.chainId
          ) {
            toast.error(`Please select BNB smartchain!!`);
            setShowModal(false);
            return false;
          }
          let MrmintContractCall = new web3.eth.Contract(
            config.mrmintContractAbi,
            config.contractAddressForRecharge
          );

          const accounts = await window.ethereum.request({
            method: "eth_requestAccounts",
          });
          let from_address = accounts[0];
          if (
            loginData.bnb_address &&
            loginData.bnb_address.toLowerCase() != from_address.toLowerCase()
          ) {
            toast.error(`Please connect with registered wallet`);
            setShowModal(false);
            return false;
          }
          let balanceOf = await MrmintContractCall.methods
            .balanceOf(accounts[0])
            .call();
          let contractWallet = new web3.eth.Contract(
            config.nftBoxContractAbi,
            config.nftBoxPurchaseContractAddress
          );
          let usdtValue = nftBoxValue;
          let usdt = Web3.utils.toWei(usdtValue.toString(), "ether");
          let getpurchaseStepByToken = await contractWallet.methods
            .getUsdtInMnt(usdt.toString())
            .call();

          let updateAmountToken = parseFloat(
            (parseInt(getpurchaseStepByToken) / 10 ** 18 + 5).toFixed(6)
          );
          // setPlanPrice(updateAmountToken);
          balanceOf = parseFloat((parseInt(balanceOf) / 10 ** 18).toFixed(6));
          if (!loginData.id) {
            setShowModal(false);
            toast.error(
              "You need to connect with your Meta mask Wallet before purchase"
            );
            return;
          }
          if (updateAmountToken > balanceOf) {
            toast.error(`Insufficient Balance`);
            setShowModal(false);
            return;
          }
          let approval = await approve(
            config.mrmintContractAbi,
            config.contractAddressForRecharge,
            updateAmountToken,
            config.nftBoxPurchaseContractAddress,
            from_address
          );

          if (approval) {
            try {
              setprocess("Your transaction is processing");
              let purchaseStepByToken =
                await contractWallet.methods.addInvestment(1);

              let encoded_tx = purchaseStepByToken.encodeABI();
              let gasPrice = await web3.eth.getGasPrice();
              gasPrice = parseInt(gasPrice) + 5 * 10 ** 9;

              //fees for buyPlan trx
              let getBalace = await web3.eth.getBalance(from_address);
              let fees = (285000 * parseInt(gasPrice)) / 10 ** 18;
              let currentBal = parseFloat(
                (parseInt(getBalace) / 10 ** 18).toFixed(6)
              );
              if (fees > currentBal) {
                toast.error(
                  `Insufficient gas fee for transaction, Minimum ${parseFloat(
                    fees
                  ).toFixed(6)} BNB balanace required for transaction`
                );
                setShowModal(false);
                return false;
              }

              let gasLimit = await web3.eth.estimateGas({
                gasPrice: web3.utils.toHex(gasPrice),
                to: config.nftBoxPurchaseContractAddress,
                from: from_address,
                data: encoded_tx,
              });

              let trx = await web3.eth.sendTransaction({
                gasPrice: web3.utils.toHex(gasPrice),
                gas: web3.utils.toHex(gasLimit),
                to: config.nftBoxPurchaseContractAddress,
                from: from_address,
                data: encoded_tx,
              });
              console.log("trxxxxx", trx);
              if (trx) {
                setbuyTransactionHash(trx.transactionHash);
                toast.success("Transaction has been created successfully");
                setTimeout(() => {
                  setShowModal(true);
                  let timer = 120;
                  setInterval(() => {
                    timer -= 1;
                    setMintingTimer(timer);
                    if (timer <= 0) {
                      window.location.reload();
                    }
                  }, 1500);
                }, 1000);
              }
            } catch (err) {
              setShowModal(false);
              if (err.code == -32603) {
                toast.error("Insufficent Allowance : " + err.message);
              }
              if (err.code == -32000) {
                toast.error("Gas Required Exceeds : " + err.message);
              }
              if (err.message.toString().split("insufficient funds")[1]) {
                settransactionError("Transaction reverted : " + err.message);
                toast.error("Transaction reverted : " + err.message);
              } else {
                if (err.toString().split("execution reverted:")[1]) {
                  toast.error(
                    "Transaction reverted : " +
                      err
                        .toString()
                        .split("execution reverted:")[1]
                        .toString()
                        .split("{")[0]
                  );
                  settransactionError(
                    "Transaction reverted : " +
                      err
                        .toString()
                        .split("execution reverted:")[1]
                        .toString()
                        .split("{")[0]
                  );
                } else {
                  settransactionError(err.message);
                  toast.error(err.message);
                }
              }
              setShowModal(false);
              return false;
            }
          }
          setShowModal(false);
        } else {
          toast.error("Please use Dapp browser!!");
          setShowModal(false);
        }
      }
    } catch (error) {
      console.log(error);
      switch (error.code) {
        case 4001:
          toast.error("User Rejected");
          break;
        case -32002:
          toast.error(
            "Request Already Processing, Please check your Meta Mask wallet"
          );
          break;
        case "ERR_NETWORK":
          toast.error("We're experiencing technical difficulties.");
          break;
        default:
          toast.error(error.message);
          break;
      }
      setShowModal(false);
    }
  };

  const getDataForNftDetails = async () => {
    try {
      const res = await getboxDetailsAction();
      if (res.success) {
        setNftBoxDetails(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const copieBtn = async () => {
    toast.success(`Copied!!`);
  };
  const redirect = () => {
    setShowModalLoad(false);
    window.location.reload();
  };

  const getBoxInvestmentHistory = async () => {
    try {
      const data = {
        page: page,
        limit: 12,
      };
      const res = await getBoxInvestmentHistoryAction(data);
      if (res.data.history.length == 0) {
        setpaginationStatus(true);
      }
      if (res.success) {
        setnftHystory((prevData) => [...prevData, ...res.data.history]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleLoadMore = () => {
    setPage(page + 1);
  };

  return (
    <>
      <Dashboardheader />
      <div className="position-relative">
        <div className="db1"></div>
        {/* <div className="db3"></div> */}
        <div className="db4"></div>
        <div className="db5"></div>
        <div className="db6"></div>
        <div className="db7"></div>
        <div className="db8"></div>

        <Container className="py-5">
          <Row className="gy-3 ">
            <Col>
              <div className="nftbox-card3 d-flex flex-column justify-content-center text-white h-100 px-4 pt-4 py-3">
                <Row>
                  <Col>
                    <h3 style={{ fontWeight: 700 }} className="sofia-sans">NFT Box</h3>
                    <p className="nft-card-no mb-1 sofia-sans">Total Subscription</p>
                  </Col>
                  <Col className="text-end mt-1">
                    <h5 className="sofia-sans" style={{ fontWeight: 600 }}>
                      {" "}
                      {nftBoxDetails.amount_usd}
                    </h5>
                    <p  className="nft-card-no mb-1 sofia-sans">
                      {nftBoxDetails.amount_mnt}
                    </p>
                  </Col>
                </Row>
                {/* <img src="assets/images/nftbackground.png" className="position-absolute" style={{opacity:0.4}} alt="" /> */}
                <div className="w-100 d-flex flex-row justify-content-center gap-4">
                  <img src="assets/images/nftbox2.svg" alt="" />
                  <img
                    className="glow-img"
                    src="assets/images/nftbox1.svg"
                    alt=""
                  />
                  <img src="assets/images/nftbox2.svg" alt="" />
                </div>
              </div>
            </Col>
            <Col
              style={{ border: "1px solid #ffffff50", borderRadius: 10 }}
              className="d-flex flex-column align-items-center justify-content-center py-3 mx-2"
            >
              <Row className="gy-3">
                <Col lg={12}>
                  <div className="nft-details-column highlight d-flex justify-content-between p-2">
                    <p className="mb-0">Category</p>
                    <p className="mb-0">{nftBoxDetails.category_name}</p>
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="nft-details-column d-flex justify-content-between p-2 ">
                    <p className="mb-0">Valid Till</p>
                    <p className="mb-0">{nftBoxDetails.validity}</p>
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="nft-details-column d-flex justify-content-between p-2">
                    <p className="mb-0">Max Steps</p>
                    <p className="mb-0">{nftBoxDetails.max_steps}</p>
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="nft-details-column d-flex justify-content-between p-2">
                    <p className="mb-0">Per Day Reward</p>
                    <p className="mb-0">{nftBoxDetails.reward_percent}</p>
                  </div>
                </Col>

                <Col
                  lg={12}
                  className=" d-flex px-0 align-items-center justify-content-center"
                >
                  <Row className="gy-2 px-0  w-100">
                    <Col lg={12} className=" d-flex justify-content-center">
                      <button
                        className="nftbox-submit w-100"
                        onClick={handleAddMore}
                      >
                        {" "}
                        Add More Amount
                      </button>
                      {/* <button className='nftbox-submit w-100' onClick={handleBuyNFTBox}>Proceed</button> */}
                    </Col>

                    {/* <Col lg={6} className=" d-flex justify-content-center">
                    <button className="nftbox-submit w-100"  style={{ textDecoration: "none", color: "white" }}
                        onClick={handleBuyNFTBox}>
                      {" "}
                      
                        Buy Now
                      
                    </button>
                  </Col>  */}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <br />
          <br />

          <Container>
            <div className="latest_transaction  mb-5 text-white">
              <h3 className="sofia-sans">Transaction History</h3>
              <div className="table-responsive mt-3">
                <table width="100%" className="text-center card-view sofia-sans">
                  <thead>
                    <tr className="table-head">
                      <th>S.No</th>

                      <th>Amount</th>
                      <th>Subscription date</th>
                      <th>Expiry date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {nftHystory?.map((item, index) => (
                      <tr className="tr_list" key={index}>
                        <td>{index + 1}</td>
                        <td>
                          ${item.amount_usd} ~{item.amount_mnt} MNT
                        </td>
                        <td>{item.investment_date}</td>
                        <td>{item.expiry_date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {nftHystory.length == 0 ? (
                  <div
                    className="text-center d-flex justify-content-center align-items-center flex-column "
                    style={{
                      padding: "20px",
                      color: "#d3d3d3",
                      borderRadius: "8px",
                      height: "60vh",
                    }}
                  >
                    <img
                      style={{ width: "auto", height: "auto" }}
                      src="assets\images\newdesign\nodata-new.png"
                    />
                    <h4>No data found</h4>
                  </div>
                ) : (
                  <>
                    {nftHystory.length >= 10 && (
                      <>
                        {!paginationStatus && (
                          <center>
                            <div
                              onClick={handleLoadMore}
                              className="gap-2 mt-2 py-3 joined-user"
                              style={{
                                color: "white",
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "black",
                                width: 180,
                                borderRadius: 8,
                              }}
                            >
                              <div className="ani-container">
                                <div className="chevron"></div>
                                <div className="chevron"></div>
                                <div className="chevron"></div>
                              </div>
                              <div style={{ fontWeight: 500 }} className="">
                                Load More
                              </div>
                            </div>
                          </center>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </Container>
        </Container>
      </div>
    </>
  );
};

export default NftboxDetails;
